const handleAppBarItems = function(route) {
  let response = {
    showGift: true,
    // Desktop nav bar items
    items: [
      {
        id: 0,
        label: this.$t('shared.one_day_trips'),
        link: "one-day",
        isVueRoute: true
      },
      // Temporarily commented out to disable more days trips
      // {
      //   id: 1,
      //   label: this.$t('shared.plus_one_day_trips'),
      //   link: "more-days",
      //   isVueRoute: true
      // },
      {
        id: 2,
        label: this.$t('shared.thailand'),
        link: "thailanding",
        isVueRoute: true
      },
      {
        id: 3,
        label: this.$t('shared.bali'),
        link: "balilanding",
        isVueRoute: true
      }
    ]
  };
  if (route.name) {
    switch (route.name) {
      case "checkout": case "calendar": case "gift": case "gifts-destinations": case "gifts-form": case "gifts-confirmation": case "gifts-destination-details":
        response = {
          showGift: false,
          items: [
            {
              id: 1,
              label: this.$t('shared.help'),
              link: "help",
              isVueRoute: true
            }
          ]
        };
        break;
      default:
        break;
    }
  }

  return response;
};

export default handleAppBarItems;
